import React from "react";
import { Col } from "react-bootstrap";
import { Link } from "react-router-dom";



const CategoryCard = ({ img, title, id }) => {
  let imageUrl = img;
  if (imageUrl.startsWith('http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/')) {
    imageUrl = imageUrl.replace('http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/', '');
  }
  else if (imageUrl.startsWith('http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/')) {
    imageUrl = imageUrl.replace('http://127.0.0.1:8000/categories/', '');
  }
  else if (imageUrl.startsWith('http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/')) {
    imageUrl = imageUrl.replace('http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/', '');
  }
  else {
    imageUrl = img;
  }
  return (
    <Col
      xs="12"
      sm="6"
      lg="3"
      className="my-4 d-flex justify-content-between" >
      <Link to={`/product/category/${id}`} className="d-block mx-auto">
        <div className="w-200px h-200px category-bg shadow Justify-content-center d-flex align-items-center rounded-circle">
          <img alt="category-image" src={imageUrl} className="categoty-card-img d-block mx-auto" />
        </div>
        <p className="mb-2 fs-20 fw-bold text-center dark-color mt-4">{title}</p>
      </Link>
    </Col>
  );
};

export default CategoryCard;
